var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgManagePayment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5178 9.23974V15.2481C22.5178 18.8414 20.4644 20.3814 17.3844 20.3814H7.12942C6.60442 20.3814 6.10275 20.3348 5.63609 20.2298C5.34442 20.1831 5.06443 20.1015 4.80776 20.0081C3.05776 19.3548 1.99609 17.8381 1.99609 15.2481V9.23974C1.99609 5.6464 4.04942 4.10645 7.12942 4.10645H17.3844C19.9978 4.10645 21.8761 5.21477 22.3778 7.74644C22.4594 8.21311 22.5178 8.6914 22.5178 9.23974Z",
    stroke: "#414449",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0184 12.7394V18.7478C26.0184 22.3411 23.9651 23.881 20.8851 23.881H10.6301C9.76672 23.881 8.98506 23.7644 8.3084 23.5078C6.92006 22.9944 5.97505 21.9328 5.63672 20.2294C6.10339 20.3344 6.60505 20.381 7.13005 20.381H17.3851C20.4651 20.381 22.5184 18.8411 22.5184 15.2478V9.23939C22.5184 8.69106 22.4717 8.20109 22.3784 7.74609C24.5951 8.21276 26.0184 9.77606 26.0184 12.7394Z",
    stroke: "#414449",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.248 15.33C13.949 15.33 15.328 13.951 15.328 12.2499C15.328 10.5489 13.949 9.16992 12.248 9.16992C10.5469 9.16992 9.16797 10.5489 9.16797 12.2499C9.16797 13.951 10.5469 15.33 12.248 15.33Z",
    stroke: "#414449",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.57812 9.68262V14.816",
    stroke: "#414449",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9258 9.68359V14.817",
    stroke: "#414449",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagePayment);
export default __webpack_public_path__ + "static/media/manage-payment.16c699638983d789e2a3f5fd6d2dc758.svg";
export { ForwardRef as ReactComponent };